'use client';

export function SiteFooter() {
  return (
    <footer
      style={{
        marginTop: '3rem',
        padding: '0',
        background: 'transparent'
      }}
    >
      {/* Divider */}
      <div style={{
        maxWidth: '1100px',
        margin: '0 auto 1.5rem',
        height: '1px',
        background: 'linear-gradient(90deg, transparent, var(--color-border), transparent)'
      }} />
      
      <div
        style={{
          maxWidth: '1100px',
          margin: '0 auto',
          padding: '0 1.5rem 2rem'
        }}
      >
        {/* Footer Links and Copyright */}
        <div
          className="py-6 text-xs"
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '1rem',
            color: 'var(--color-text-tertiary)'
          }}
        >
          <span style={{ fontWeight: 500 }}>
            © {new Date().getFullYear()} Amaya Stories. All rights reserved.
          </span>
          <nav style={{ 
            display: 'flex', 
            gap: '1rem', 
            flexWrap: 'wrap', 
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <a 
              href="/pricing" 
              style={{ 
                color: 'var(--color-text-secondary)', 
                textDecoration: 'none',
                fontWeight: 500,
                transition: 'all var(--transition-fast)',
                position: 'relative'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = 'var(--color-primary)';
                e.currentTarget.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'var(--color-text-secondary)';
                e.currentTarget.style.textDecoration = 'none';
              }}
            >
              Pricing
            </a>
            <a 
              href="/blogs" 
              style={{ 
                color: 'var(--color-text-secondary)', 
                textDecoration: 'none',
                fontWeight: 500,
                transition: 'all var(--transition-fast)',
                position: 'relative'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = 'var(--color-primary)';
                e.currentTarget.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'var(--color-text-secondary)';
                e.currentTarget.style.textDecoration = 'none';
              }}
            >
              Blogs
            </a>
            <a 
              href="/privacy" 
              style={{ 
                color: 'var(--color-text-secondary)', 
                textDecoration: 'none',
                fontWeight: 500,
                transition: 'all var(--transition-fast)',
                position: 'relative'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = 'var(--color-primary)';
                e.currentTarget.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'var(--color-text-secondary)';
                e.currentTarget.style.textDecoration = 'none';
              }}
            >
              Privacy Policy
            </a>
            <a 
              href="/terms" 
              style={{ 
                color: 'var(--color-text-secondary)', 
                textDecoration: 'none',
                fontWeight: 500,
                transition: 'all var(--transition-fast)',
                position: 'relative'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = 'var(--color-primary)';
                e.currentTarget.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'var(--color-text-secondary)';
                e.currentTarget.style.textDecoration = 'none';
              }}
            >
              Terms of Service
            </a>
            <a 
              href="/contact" 
              style={{ 
                color: 'var(--color-text-secondary)', 
                textDecoration: 'none',
                fontWeight: 500,
                transition: 'all var(--transition-fast)',
                position: 'relative'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = 'var(--color-primary)';
                e.currentTarget.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'var(--color-text-secondary)';
                e.currentTarget.style.textDecoration = 'none';
              }}
            >
              Contact
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
